<template>
  <div>
    <card>
      <div class="card-header-custom">
        <button type="submit" @click="toggleSelectAll" class="btn btn-fill btn-primary mr-3">
          Alle auswählen
        </button>

        <button class="btn btn-success" @click="restoreselectedSuppliers">
          <i class="fa fa-recycle"></i>
          Ausgewählte Lieferanten wiederherstellen
        </button>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <p v-if="suppliers.length === 0">Keine gelöschten Lieferanten vorhanden.</p>
          <transition name="el-fade-in-linear">
            <table class="table table-striped table-bordered" v-if="suppliers.length">
              <thead>
                <tr>
                  <th width="10px">&nbsp;</th>
                  <th>Kundennumer</th>
                  <th>Name</th>
                  <th>E-Mail</th>
                  <th>Straße</th>
                  <th>PLZ</th>
                  <th>Ort</th>
                  <th>Land</th>
                </tr>
              </thead>
              <tr v-for="supplier in suppliers" :key="supplier.id">
                <td class="handle"> <input type="checkbox" :value="supplier.id" v-model="selectedSuppliers"></td>
                <td v-text="supplier.customer_number"></td>
                <td v-text="supplier.name"></td>
                <td v-text="supplier.email"></td>
                <td v-text="supplier.street"></td>
                <td v-text="supplier.zip"></td>
                <td v-text="supplier.place"></td>
                <td v-text="supplier.country"></td>
              </tr>
            </table>
          </transition>
        </div>
      </div>
       <a href="/suppliers">
         <button type="submit" class="btn btn-fill btn-info mr-3">
          Zurück
        </button>
      </a>
    </card>
  </div>
</template>

<script>

export default {
  data() {
    return {
      suppliers: [],
      selectedSuppliers: [],
      selectAll: false,
    }
  },
  methods: {
    getData(query) {
      this.$http.get(`/soft_deleted/suppliers`).then(({ data }) => {
        this.suppliers = data

      })
    },
    toggleSelectAll() {
      this.selectAll = !this.selectAll
      if (this.selectAll) {
        this.selectedSuppliers = this.suppliers.map(supplier => supplier.id);
      } else {
        this.selectedSuppliers = [];
      }
    },
    restoreselectedSuppliers() {
      if (this.selectedSuppliers.length) {
        const selectedSuppliers = this.suppliers.filter(supplier => this.selectedSuppliers.includes(supplier.id));
        const selectedSuppliersIds = selectedSuppliers.map(supplier => supplier.id)
        const selectedSuppliersNames = selectedSuppliers.map(supplier => supplier.name)
        this.$http.post(`/soft_deleted/suppliers/restore`, { ids: selectedSuppliersIds }).then(() => {
          this.$notify({
            message: `Lieferanten: ${selectedSuppliersNames} erfolgreich wiederhergestellt.`,
            type: 'success'
          });
          this.getData();
          setTimeout(() => {
            this.$router.push('/suppliers');
          }, 2000);
        })
      }
    },
  },
  created() {
    this.getData()
  }
}
</script>
